export default function actHack(callback) {
  callback();
}